import { render, staticRenderFns } from "./productSecond.vue?vue&type=template&id=6b38a0bf&scoped=true"
import script from "./productSecond.vue?vue&type=script&lang=js"
export * from "./productSecond.vue?vue&type=script&lang=js"
import style0 from "./productSecond.vue?vue&type=style&index=0&id=6b38a0bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38a0bf",
  null
  
)

export default component.exports